import { render } from "./Topics.vue?vue&type=template&id=55d7cf53"
import script from "./Topics.vue?vue&type=script&lang=ts"
export * from "./Topics.vue?vue&type=script&lang=ts"

import "./Topics.vue?vue&type=style&index=0&id=55d7cf53&lang=scss"
script.render = render

export default script